import { bl_fi_deposit_register_txn_line_RowClass } from '../../dbschema/bl_fi_deposit_register_txn_line.model';
import { BaseContainerModel } from '../base-container.model';

export class DepositRegisterTxnLineContainerModel extends BaseContainerModel {
  bl_fi_deposit_register_txn_line: bl_fi_deposit_register_txn_line_RowClass = new bl_fi_deposit_register_txn_line_RowClass();
}
